import { map, flatten, uniqBy, isEqual } from 'lodash';
export const filterRanges = (ranges, selectedFilter) => selectedFilter ? ranges.filter(range => range.slug === selectedFilter) : ranges;
export const calucateCount = ranges => uniqBy(flatten(map(ranges, 'items')), 'slug').length;
function makeUpdater(arrayParamVal, arrayParamSetter, arrayParamOptions) {
  return function (newSelection) {
    const processedNewSelection = [...newSelection].sort().filter(val => arrayParamOptions.includes(val));
    if (!isEqual(arrayParamVal, processedNewSelection)) {
      arrayParamSetter(processedNewSelection, 'pushIn');
    }
  };
}
export const makeMultiFilterProps = (values, setter, options) => {
  const definiteValues = values || [];
  const definiteOptions = options || [];
  return {
    filterOptions: definiteOptions,
    selectedOptions: definiteValues,
    onSelectionChange: makeUpdater(definiteValues, setter, definiteOptions)
  };
};